import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import transformMultilineStop from 'src/app/component/shared/others/multiline-stop';
import { darkTimepickerTheme } from '../../../shared/others/timepicker-field-theme';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface TimeTableTripEditInput {
  trip;
  routeStops;
  buses;
}
@Component({
  selector: 'app-mock-edit-trip',
  templateUrl: './mock-edit-trip.component.html',
  styleUrls: ['./mock-edit-trip.component.scss'],
})
export class MockEditTripComponent implements OnInit {
  constructor(
    private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<MockEditTripComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: TimeTableTripEditInput
  ) {}
  timePickerTheme = darkTimepickerTheme;
  tripData;
  tripStops;
  buses = [];
  skipTrip = true;
  project = 'DEMO';
  offsetOperations = ['+', '-'];
  offsetValue = '+';
  offsetMinutes = 0;
  offsetSeconds = 0;

  ngOnInit() {
    const tripCopy = JSON.parse(JSON.stringify(this.dialogData.trip));
    tripCopy.stops.forEach(stop => {
      if (this.skipTrip) stop.skip = stop?.skip ?? false;
      stop.stopName =
        this.dialogData.routeStops.find(
          routeStop => routeStop.stopCode === stop.stopId
        )?.stopName ?? '';
      stop.multilineStop = transformMultilineStop(stop.stopName);
    });
    this.tripData = tripCopy;
    this.buses = [...this.dialogData.buses];
    console.log('modal: ', { tripData: this.tripData });
  }

  onEdit() {
    console.log(this.tripData);
    // call API for edit
    this.dialogRef.close({
      tripData: this.tripData,
      operation: {
        offsetValue: this.offsetValue,
        offsetMinutes: this.offsetMinutes,
      },
    });
  }
}
